export const IMAGE_CDN_ORIGIN = 'https://img.ymcdn.net'

export const country = {
  ID: 'ID-Indonesia',
  IN: 'IN-India',
  PH: 'PH-Philippines',
}

export const timezone = {
  '0': 'UTC+0',
  '1': 'UTC+1',
  '2': 'UTC+2',
  '3': 'UTC+3',
  '4': 'UTC+4',
  '5': 'UTC+5',
  '6': 'UTC+6',
  '7': 'UTC+7',
  '8': 'UTC+8',
  '9': 'UTC+9',
  '10': 'UTC+10',
  '11': 'UTC+11',
  '12': 'UTC+12',
  '-12': 'UTC-12',
  '-11': 'UTC-11',
  '-10': 'UTC-10',
  '-9': 'UTC-9',
  '-8': 'UTC-8',
  '-7': 'UTC-7',
  '-6': 'UTC-6',
  '-5': 'UTC-5',
  '-4': 'UTC-4',
  '-3': 'UTC-3',
  '-2': 'UTC-2',
  '-1': 'UTC-1',
}

export const businessType = {
  1: 'Direct Install',
  2: 'Keyword Install',
  3: 'Rating',
  4: 'Reviews',
  5: 'Likes to Review',
  7:'Custom Reviews',
  8: 'Instagram Follow',
  9: 'Instagram Post Like',
  10: 'Youtube Subscribe',
  11: 'Youtube Comment',
  12: 'Keyword Install Rating',
  13: 'Keyword Install Custom Reviews',
  14: 'Guaranteed Reviews',
  15: 'Likes&Dislikes',
  16: 'Follow/Subscribe',
  17: 'Post Like',
  18: 'Social Media Review',
  19: 'Google Maps Ratings and Reviews',
}

export const mediaOptions = {
  8: 'Instagram Follow',
  9: 'Instagram Post Like',
  10: 'Youtube Subscribe',
  11: 'Youtube Comment',
}

export const campaignStatus = {
  4: 'Active',
  5: 'Pause',
  6: 'Cancel',
}

export const countryAll = {
  AD: 'AD-Andorra',
  AE: 'AE-United Arab Emirates',
  AF: 'AF-Afghanistan',
  AG: 'AG-Antigua and Barbuda',
  AI: 'AI-Anguilla',
  AL: 'AL-Albania',
  AM: 'AM-Armenia',
  AO: 'AO-Angola',
  AQ: 'AQ-Antarctica',
  AR: 'AR-Argentina',
  AS: 'AS-American Samoa',
  AT: 'AT-Austria',
  AU: 'AU-Australia',
  AW: 'AW-Aruba',
  AX: 'AX-Aland Islands',
  AZ: 'AZ-Azerbaijan',
  BA: 'BA-Bosnia and Herzegovina',
  BB: 'BB-Barbados',
  BD: 'BD-Bangladesh',
  BE: 'BE-Belgium',
  BF: 'BF-Burkina Faso',
  BG: 'BG-Bulgaria',
  BH: 'BH-Bahrain',
  BI: 'BI-Burundi',
  BJ: 'BJ-Benin',
  BL: 'BL-Saint Barthelemy',
  BM: 'BM-Bermuda',
  BN: 'BN-Brunei Darussalam',
  BO: 'BO-Bolivia',
  BQ: 'BQ-Bonaire, Sint Eustatius and Saba',
  BR: 'BR-Brazil',
  BS: 'BS-Bahamas',
  BT: 'BT-Bhutan',
  BV: 'BV-Bouvet Island',
  BW: 'BW-Botswana',
  BY: 'BY-Belarus',
  BZ: 'BZ-Belize',
  CA: 'CA-Canada',
  CC: 'CC-Cocos Islands',
  CD: 'CD-Congo (Democratic Republic of the)',
  CF: 'CF-Central African Republic',
  CG: 'CG-Congo',
  CH: 'CH-Switzerland',
  CI: 'CI-Cote d\'Ivoire',
  CK: 'CK-Cook Islands',
  CL: 'CL-Chile',
  CM: 'CM-Cameroon',
  CN: 'CN-China',
  CO: 'CO-Colombia',
  CR: 'CR-Costa Rica',
  CU: 'CU-Cuba',
  CV: 'CV-Cabo Verde',
  CW: 'CW-Curacao',
  CX: 'CX-Christmas Island',
  CY: 'CY-Cyprus',
  CZ: 'CZ-Czech Republic',
  DE: 'DE-Germany',
  DJ: 'DJ-Djibouti',
  DK: 'DK-Denmark',
  DM: 'DM-Dominica',
  DO: 'DO-Dominican Republic',
  DZ: 'DZ-Algeria',
  EC: 'EC-Ecuador',
  EE: 'EE-Estonia',
  EG: 'EG-Egypt',
  EH: 'EH-Western Sahara',
  ER: 'ER-Eritrea',
  ES: 'ES-Spain',
  ET: 'ET-Ethiopia',
  FI: 'FI-Finland',
  FJ: 'FJ-Fiji',
  FK: 'FK-Falkland Islands (Malvinas)',
  FM: 'FM-Micronesia (Federated States of)',
  FO: 'FO-Faroe Islands',
  FR: 'FR-France',
  GA: 'GA-Gabon',
  GB: 'GB-United Kingdom of Great Britain and Northern Ireland',
  GD: 'GD-Grenada',
  GE: 'GE-Georgia',
  GF: 'GF-French Guiana',
  GG: 'GG-Guernsey',
  GH: 'GH-Ghana',
  GI: 'GI-Gibraltar',
  GL: 'GL-Greenland',
  GM: 'GM-Gambia',
  GN: 'GN-Guinea',
  GP: 'GP-Guadeloupe',
  GQ: 'GQ-Equatorial Guinea',
  GR: 'GR-Greece',
  GS: 'GS-South Georgia and the South Sandwich Islands',
  GT: 'GT-Guatemala',
  GU: 'GU-Guam',
  GW: 'GW-Guinea-Bissau',
  GY: 'GY-Guyana',
  HK: 'HK-Hong Kong',
  HM: 'HM-Heard Island and McDonald Islands',
  HN: 'HN-Honduras',
  HR: 'HR-Croatia',
  HT: 'HT-Haiti',
  HU: 'HU-Hungary',
  ID: 'ID-Indonesia',
  IE: 'IE-Ireland',
  IL: 'IL-Israel',
  IM: 'IM-Isle of Man',
  IN: 'IN-India',
  IO: 'IO-British Indian Ocean Territory',
  IQ: 'IQ-Iraq',
  IR: 'IR-Iran (Islamic Republic of)',
  IS: 'IS-Iceland',
  IT: 'IT-Italy',
  JE: 'JE-Jersey',
  JM: 'JM-Jamaica',
  JO: 'JO-Jordan',
  JP: 'JP-Japan',
  KE: 'KE-Kenya',
  KG: 'KG-Kyrgyzstan',
  KH: 'KH-Cambodia',
  KI: 'KI-Kiribati',
  KM: 'KM-Comoros',
  KP: 'KP-Korea (Democratic People\'s Republic of)',
  KR: 'KR-Korea (Republic of)',
  KW: 'KW-Kuwait',
  KY: 'KY-Cayman Islands',
  KZ: 'KZ-Kazakhstan',
  LA: 'LA-Lao People\'s Democratic Republic',
  LB: 'LB-Lebanon',
  LC: 'LC-Saint Lucia',
  LI: 'LI-Liechtenstein',
  LK: 'LK-Sri Lanka',
  LR: 'LR-Liberia',
  LS: 'LS-Lesotho',
  LT: 'LT-Lithuania',
  LU: 'LU-Luxembourg',
  LV: 'LV-Latvia',
  LY: 'LY-Libya',
  MA: 'MA-Morocco',
  MC: 'MC-Monaco',
  MD: 'MD-Moldova (Republic of)',
  ME: 'ME-Montenegro',
  MF: 'MF-Saint Martin (French part)',
  MG: 'MG-Madagascar',
  MH: 'MH-Marshall Islands',
  MK: 'MK-Macedonia (the former Yugoslav Republic of)',
  ML: 'ML-Mali',
  MM: 'MM-Myanmar',
  MN: 'MN-Mongolia',
  MO: 'MO-Macao',
  MP: 'MP-Northern Mariana Islands',
  MQ: 'MQ-Martinique',
  MR: 'MR-Mauritania',
  MS: 'MS-Montserrat',
  MT: 'MT-Malta',
  MU: 'MU-Mauritius',
  MV: 'MV-Maldives',
  MW: 'MW-Malawi',
  MX: 'MX-Mexico',
  MY: 'MY-Malaysia',
  MZ: 'MZ-Mozambique',
  NA: 'NA-Namibia',
  NC: 'NC-New Caledonia',
  NE: 'NE-Niger',
  NF: 'NF-Norfolk Island',
  NG: 'NG-Nigeria',
  NI: 'NI-Nicaragua',
  NL: 'NL-Netherlands',
  NO: 'NO-Norway',
  NP: 'NP-Nepal',
  NR: 'NR-Nauru',
  NU: 'NU-Niue',
  NZ: 'NZ-New Zealand',
  OM: 'OM-Oman',
  PA: 'PA-Panama',
  PE: 'PE-Peru',
  PF: 'PF-French Polynesia',
  PG: 'PG-Papua New Guinea',
  PH: 'PH-Philippines',
  PK: 'PK-Pakistan',
  PL: 'PL-Poland',
  PM: 'PM-Saint Pierre and Miquelon',
  PN: 'PN-Pitcairn',
  PR: 'PR-Puerto Rico',
  PS: 'PS-Palestine, State of',
  PT: 'PT-Portugal',
  PW: 'PW-Palau',
  PY: 'PY-Paraguay',
  QA: 'QA-Qatar',
  RE: 'RE-Reunion',
  RO: 'RO-Romania',
  RS: 'RS-Serbia',
  RU: 'RU-Russian Federation',
  RW: 'RW-Rwanda',
  SA: 'SA-Saudi Arabia',
  SB: 'SB-Solomon Islands',
  SC: 'SC-Seychelles',
  SD: 'SD-Sudan',
  SE: 'SE-Sweden',
  SG: 'SG-Singapore',
  SH: 'SH-Saint Helena, Ascension and Tristan da Cunha',
  SI: 'SI-Slovenia',
  SJ: 'SJ-Svalbard and Jan Mayen',
  SK: 'SK-Slovakia',
  SL: 'SL-Sierra Leone',
  SM: 'SM-San Marino',
  SN: 'SN-Senegal',
  SO: 'SO-Somalia',
  SR: 'SR-Suriname',
  SS: 'SS-South Sudan',
  ST: 'ST-Sao Tome and Principe',
  SV: 'SV-El Salvador',
  SX: 'SX-Sint Maarten (Dutch part)',
  SY: 'SY-Syrian Arab Republic',
  SZ: 'SZ-Swaziland',
  TC: 'TC-Turks and Caicos Islands',
  TD: 'TD-Chad',
  TF: 'TF-French Southern Territories',
  TG: 'TG-Togo',
  TH: 'TH-Thailand',
  TJ: 'TJ-Tajikistan',
  TK: 'TK-Tokelau',
  TL: 'TL-Timor-Leste',
  TM: 'TM-Turkmenistan',
  TN: 'TN-Tunisia',
  TO: 'TO-Tonga',
  TR: 'TR-Turkey',
  TT: 'TT-Trinidad and Tobago',
  TV: 'TV-Tuvalu',
  TW: 'TW-Taiwan',
  TZ: 'TZ-Tanzania',
  UA: 'UA-Ukraine',
  UG: 'UG-Uganda',
  UM: 'UM-United States Minor Outlying Islands',
  US: 'US-United States of America',
  UY: 'UY-Uruguay',
  UZ: 'UZ-Uzbekistan',
  VA: 'VA-Holy See',
  VC: 'VC-Saint Vincent and the Grenadines',
  VE: 'VE-Venezuela',
  VG: 'VG-Virgin Islands (British)',
  VI: 'VI-Virgin Islands (U.S.)',
  VN: 'VN-Vietnam',
  VU: 'VU-Vanuatu',
  WF: 'WF-Wallis and Futuna',
  WS: 'WS-Samoa',
  YE: 'YE-Yemen',
  YT: 'YT-Mayotte',
  ZA: 'ZA-South Africa',
  ZM: 'ZM-Zambia',
  ZW: 'ZW-Zimbabwe',
}

export const languageAll = {
  CN:	'Chinese',
  US:	'English',
  ES:	'Spanish',
  FR:	'French',
  DE:	'German',
  JP:	'Japanese',
  KR:	'Korean',
  RU:	'Russian',
  SA:	'Arabic',
  PT:	'Portuguese',
  IT:	'Italian',
  NL:	'Dutch',
  SE:	'Swedish',
  NO:	'Norwegian',
  DK:	'Danish',
  FI:	'Finnish',
  GR:	'Greek',
  PL:	'Polish',
  CZ:	'Czech',
  TR:	'Turkish',
  HU:	'Hungarian',
  TH:	'Thai',
  VN:	'Vietnamese',
  ID:	'Indonesian',
  MY:	'Malay',
}

export const countrySupport = {
  ID: 'ID-Indonesia',
  IN: 'IN-India',
  PH: 'PH-Philippines',
  US: 'US-United States of America',
  NG: 'NG-Nigeria',
  TH: 'TH-Thailand',
  VN: 'VN-Vietnam',
  BR: 'BR-Brazil',
  MX: 'MX-Mexico',
  MY: 'MY-Malaysia',
  BD: 'BD-Bangladesh',
  PK: 'PK-Pakistan',
}

export const languageGuaranteed = {
  ID:	'ID-Indonesian',
  IN:	'IN-Hindi',
  NG:	'NG-English',
  PH:	'PH-Filipino',
  MX:	'MX-Spanish',
  BR:	'BR-Portuguese',
  VN:	'VN-Vietnamese',
  TH:	'TH-Thai',
  US:	'US-English',
  MY:	'MY-Malay',
  BD:	'BD-Bengali',
  PK:	'PK-Urdu',
}


export const countryAllCN = {
  AD: '安道尔',
  AE: '阿联酋',
  AF: '阿富汗',
  AG: '安提瓜和巴布达',
  AI: '安圭拉',
  AL: '阿尔巴尼亚',
  AM: '亚美尼亚',
  AO: '安哥拉',
  AQ: '南极洲',
  AR: '阿根廷',
  AS: '美属萨摩亚',
  AT: '奥地利',
  AU: '澳大利亚',
  AW: '阿鲁巴',
  AX: '奥兰群岛',
  AZ: '阿塞拜疆',
  BA: '波黑',
  BB: '巴巴多斯',
  BD: '孟加拉国',
  BE: '比利时',
  BF: '布基纳法索',
  BG: '保加利亚',
  BH: '巴林',
  BI: '布隆迪',
  BJ: '贝宁',
  BL: '圣巴泰勒米',
  BM: '百慕大',
  BN: '文莱',
  BO: '玻利维亚',
  BQ: '荷属加勒比区',
  BR: '巴西',
  BS: '巴哈马',
  BT: '不丹',
  BV: '布韦岛',
  BW: '博茨瓦纳',
  BY: '白俄罗斯',
  BZ: '伯利兹',
  CA: '加拿大',
  CC: '可可斯（基林）群岛',
  CD: '刚果民主共和国',
  CF: '中非共和国',
  CG: '刚果共和国',
  CH: '瑞士',
  CI: '科特迪瓦',
  CK: '库克群岛',
  CL: '智利',
  CM: '喀麦隆',
  CN: '中国',
  CO: '哥伦比亚',
  CR: '哥斯达黎加',
  CU: '古巴',
  CV: '佛得角',
  CW: '库拉索',
  CX: '圣诞岛',
  CY: '塞浦路斯',
  CZ: '捷克',
  DE: '德国',
  DJ: '吉布提',
  DK: '丹麦',
  DM: '多米尼克',
  DO: '多米尼加共和国',
  DZ: '阿尔及利亚',
  EC: '厄瓜多尔',
  EE: '爱沙尼亚',
  EG: '埃及',
  EH: '西撒哈拉',
  ER: '厄立特里亚',
  ES: '西班牙',
  ET: '埃塞俄比亚',
  FI: '芬兰',
  FJ: '斐济',
  FK: '马尔维纳斯群岛（福克兰）',
  FM: '密克罗尼西亚',
  FO: '法罗群岛',
  FR: '法国',
  GA: '加蓬',
  GB: '英国',
  GD: '格林纳达',
  GE: '格鲁吉亚',
  GF: '法属圭亚那',
  GG: '根西岛',
  GH: '加纳',
  GI: '直布罗陀',
  GL: '格陵兰',
  GM: '冈比亚',
  GN: '几内亚',
  GP: '瓜德罗普',
  GQ: '赤道几内亚',
  GR: '希腊',
  GS: '南乔治亚和南桑威奇群岛',
  GT: '危地马拉',
  GU: '关岛',
  GW: '几内亚比绍',
  GY: '圭亚那',
  HK: '中国香港',
  HM: '赫德岛和麦克唐纳群岛',
  HN: '洪都拉斯',
  HR: '克罗地亚',
  HT: '海地',
  HU: '匈牙利',
  ID: '印度尼西亚',
  IE: '爱尔兰',
  IL: '以色列',
  IM: '马恩岛',
  IN: '印度',
  IO: '英属印度洋领地',
  IQ: '伊拉克',
  IR: '伊朗',
  IS: '冰岛',
  IT: '意大利',
  JE: '泽西岛',
  JM: '牙买加',
  JO: '约旦',
  JP: '日本',
  KE: '肯尼亚',
  KG: '吉尔吉斯斯坦',
  KH: '柬埔寨',
  KI: '基里巴斯',
  KM: '科摩罗',
  KP: '朝鲜',
  KR: '韩国',
  KW: '科威特',
  KY: '开曼群岛',
  KZ: '哈萨克斯坦',
  LA: '老挝',
  LB: '黎巴嫩',
  LC: '圣卢西亚',
  LI: '列支敦士登',
  LK: '斯里兰卡',
  LR: '利比里亚',
  LS: '莱索托',
  LT: '立陶宛',
  LU: '卢森堡',
  LV: '拉脱维亚',
  LY: '利比亚',
  MA: '摩洛哥',
  MC: '摩纳哥',
  MD: '摩尔多瓦',
  ME: '黑山',
  MF: '法属圣马丁',
  MG: '马达加斯加',
  MH: '马绍尔群岛',
  MK: '北马其顿',
  ML: '马里',
  MM: '缅甸',
  MN: '蒙古',
  MO: '中国澳门',
  MP: '北马里亚纳群岛',
  MQ: '马提尼克',
  MR: '毛里塔尼亚',
  MS: '蒙特塞拉特',
  MT: '马耳他',
  MU: '毛里求斯',
  MV: '马尔代夫',
  MW: '马拉维',
  MX: '墨西哥',
  MY: '马来西亚',
  MZ: '莫桑比克',
  NA: '纳米比亚',
  NC: '新喀里多尼亚',
  NE: '尼日尔',
  NF: '诺福克岛',
  NG: '尼日利亚',
  NI: '尼加拉瓜',
  NL: '荷兰',
  NO: '挪威',
  NP: '尼泊尔',
  NR: '瑙鲁',
  NU: '纽埃',
  NZ: '新西兰',
  OM: '阿曼',
  PA: '巴拿马',
  PE: '秘鲁',
  PF: '法属波利尼西亚',
  PG: '巴布亚新几内亚',
  PH: '菲律宾',
  PK: '巴基斯坦',
  PL: '波兰',
  PM: '圣皮埃尔和密克隆',
  PN: '皮特凯恩群岛',
  PR: '波多黎各',
  PS: '巴勒斯坦',
  PT: '葡萄牙',
  PW: '帕劳',
  PY: '巴拉圭',
  QA: '卡塔尔',
  RE: '留尼汪',
  RO: '罗马尼亚',
  RS: '塞尔维亚',
  RU: '俄罗斯',
  RW: '卢旺达',
  SA: '沙特阿拉伯',
  SB: '所罗门群岛',
  SC: '塞舌尔',
  SD: '苏丹',
  SE: '瑞典',
  SG: '新加坡',
  SH: '圣赫勒拿',
  SI: '斯洛文尼亚',
  SJ: '斯瓦尔巴和扬马延',
  SK: '斯洛伐克',
  SL: '塞拉利昂',
  SM: '圣马力诺',
  SN: '塞内加尔',
  SO: '索马里',
  SR: '苏里南',
  SS: '南苏丹',
  ST: '圣多美和普林西比',
  SV: '萨尔瓦多',
  SX: '荷属圣马丁',
  SY: '叙利亚',
  SZ: '斯威士兰',
  TC: '特克斯和凯科斯群岛',
  TD: '乍得',
  TF: '法属南部和南极领地',
  TG: '多哥',
  TH: '泰国',
  TJ: '塔吉克斯坦',
  TK: '托克劳',
  TL: '东帝汶',
  TM: '土库曼斯坦',
  TN: '突尼斯',
  TO: '汤加',
  TR: '土耳其',
  TT: '特立尼达和多巴哥',
  TV: '图瓦卢',
  TW: '中国台湾',
  TZ: '坦桑尼亚',
  UA: '乌克兰',
  UG: '乌干达',
  UM: '美国本土外小岛屿',
  US: '美国',
  UY: '乌拉圭',
  UZ: '乌兹别克斯坦',
  VA: '梵蒂冈',
  VC: '圣文森特和格林纳丁斯',
  VE: '委内瑞拉',
  VG: '英属维尔京群岛',
  VI: '美属维尔京群岛',
  VN: '越南',
  VU: '瓦努阿图',
  WF: '瓦利斯和富图纳',
  WS: '萨摩亚',
  YE: '也门',
  YT: '马约特',
  ZA: '南非',
  ZM: '赞比亚',
  ZW: '津巴布韦',
}

export const countrySupportCN = {
  ID: '印度尼西亚',
  IN: '印度',
  PH: '菲律宾',
  US: '美国',
  NG: '尼日利亚',
  TH: '泰国',
  VN: '越南',
  BR: '巴西',
  MX: '墨西哥',
  MY: '马来西亚',
  BD: '孟加拉国',
  PK: '巴基斯坦',
}

export const languageGuaranteedCN = {
  ID: '印度尼西亚语',
  IN: '印地语',
  NG: '英语',
  PH: '他加禄语',
  MX: '西班牙语',
  BR: '葡萄牙语',
  VN: '越南语',
  TH: '泰语',
  US: '英语',
  MY: '马来语',
  BD: '孟加拉语',
  PK: '乌尔都语',
}

export const languageAllCN = {
  CN: '中文',
  US: '英语',
  ES: '西班牙语',
  FR: '法语',
  DE: '德语',
  JP: '日语',
  KR: '韩语',
  RU: '俄语',
  SA: '阿拉伯语',
  PT: '葡萄牙语',
  IT: '意大利语',
  NL: '荷兰语',
  SE: '瑞典语',
  NO: '挪威语',
  DK: '丹麦语',
  FI: '芬兰语',
  GR: '希腊语',
  PL: '波兰语',
  CZ: '捷克语',
  TR: '土耳其语',
  HU: '匈牙利语',
  TH: '泰语',
  VN: '越南语',
  ID: '印度尼西亚语',
  MY: '马来语',
}

export const asogrowCN = {
  "asogrow_media_platform": [
    {
      "id": 1,
      "name": "Instagram"
    },
    {
      "id": 2,
      "name": "油管"
    },
    {
      "id": 3,
      "name": "抖音"
    },
    {
      "id": 4,
      "name": "脸书"
    },
    {
      "id": 5,
      "name": "推特"
    },
    {
      "id": 6,
      "name": "谷歌地图"
    }
  ],
  "asogrow_order_platform_type": [
    {
      "id": 1,
      "name": "Stripe"
    },
    {
      "id": 2,
      "name": "Payoneer（派安盈）"
    },
    {
      "id": 3,
      "name": "银行转账"
    },
    {
      "id": 4,
      "name": "免费赠金"
    },
    {
      "id": 5,
      "name": "Paypal"
    }
  ],
  "asogrow_media_target": [
    {
      "id": 1,
      "name": "关注/订阅"
    },
    {
      "id": 2,
      "name": "帖子点赞"
    },
    {
      "id": 3,
      "name": "评论"
    }
  ],
  "asogrow_price_business_type": [
    {
      "id": 1,
      "name": "应用安装"
    },
    {
      "id": 2,
      "name": "关键词安装"
    },
    {
      "id": 3,
      "name": "评分"
    },
    {
      "id": 4,
      "name": "评论"
    },
    {
      "id": 5,
      "name": "评论点赞"
    },
    {
      "id": 7,
      "name": "自定义评论"
    },
    {
      "id": 8,
      "name": "Instagram关注者"
    },
    {
      "id": 9,
      "name": "Instagram帖子点赞"
    },
    {
      "id": 10,
      "name": "油管订阅"
    },
    {
      "id": 11,
      "name": "油管评论"
    },
    {
      "id": 12,
      "name": "关键词安装并评分"
    },
    {
      "id": 13,
      "name": "关键词安装并自定义评论"
    },
    {
      "id": 14,
      "name": "保障性评论"
    },
    {
      "id": 15,
      "name": "评论点赞"
    },
    {
      "id": 16,
      "name": "关注/订阅"
    },
    {
      "id": 17,
      "name": "帖子点赞"
    },
    {
      "id": 18,
      "name": "社媒主页评价"
    },
    {
      "id": 19,
      "name": "谷歌地图评分与评论"
    }
  ],
  "asogrow_campaign_status": [
    {
      "id": 3,
      "name": "未付费"
    },
    {
      "id": 4,
      "name": "进行中"
    },
    {
      "id": 5,
      "name": "暂停"
    },
    {
      "id": 6,
      "name": "取消"
    },
    {
      "id": 7,
      "name": "未完成"
    },
    {
      "id": 8,
      "name": "已完成"
    },
    {
      "id": 9,
      "name": "未结算"
    },
    {
      "id": 10,
      "name": "预开始"
    }
  ]
}

export const businessTypeCN = {
  1: '应用安装',
  2: '关键词安装',
  3: 'Rating',
  4: '评分',
  5: '点赞评论',
  7:'自定义评论',
  8: 'Instagram关注者',
  9: 'Instagram帖子点赞',
  10: '油管订阅',
  11: '油管评论',
  12: '关键词安装并评分',
  13: '关键词安装并自定义评论',
  14: '保障性评论',
  15: '评论点赞',
  16: '关注/订阅',
  17: '帖子点赞',
  18: '社媒主页评价',
  19: '谷歌地图评分与评论',
}

export const recordTypeOptions = [
  { value: 'Stripe', labelKey: 'messages.record.record1' },
  { value: 'Payoneer', labelKey: 'messages.record.record2' },
  { value: 'Bank Transfer', labelKey: 'messages.record.record3' },
  { value: 'Cost', labelKey: 'messages.record.record4' },
  { value: 'Refund', labelKey: 'messages.record.record5' },
  { value: 'Free Bonus', labelKey: 'messages.record.record6' },
  { value: 'Bonus Cancel', labelKey: 'messages.record.record7' },
  { value: 'Manual Cost', labelKey: 'messages.record.record8' },
  { value: 'Paypal', labelKey: 'messages.record.record9' },
  { value: 'Advance Payment', labelKey: 'messages.record.record10' },
]